<!-- MINIMAP SLOT: reserva el tamaño base para que el hover no desplace las previews -->
<div
    [class]="{'hidden': isMinimapHidden}"
    class="relative w-[110px] h-[100px] md:w-[150px] md:h-[105px]"
>

    <!-- MINIMAP CONTAINER -->
    <div 
        #minimapContainer 
        (click)="onContainerClick($event)"
        (keypress.enter)="onMinimapClick()"
        [style.aspect-ratio]="boxAspectRatio()"
        [style.height]="boxAspectRatio() ? 'auto' : null"
        class="absolute bottom-0 left-0 z-30 w-full h-full md:hover:w-[240px] md:hover:h-[168px] md:focus-visible:w-[240px] md:focus-visible:h-[168px] transition-[width,height] duration-200 bg-black/80 rounded-md pointer-events-auto backdrop-blur-md overflow-hidden opacity-10 hover:opacity-100 cursor-pointer"
        tabindex="0"
    >
 
        <!-- WRAPPER -->
        <div class="h-full w-full pointer-events-none md:pointer-events-auto">

            <!-- TEMP COMMENT UNTIL ISSUE IS FIXED IN DVM -->
            <!-- @if(useNavigable){
                <dvm-navigable-minimap [linkedMapViewer]="dvmService.viewer"/> 
            }
            @else { 
                <dvm-map-viewer  class="h-full" [service]="minimap"/> 
            } -->
        
            <!-- TEMP SOLUTION -->
            <!-- NAVIGABLE MINIMAP -->
            <dvm-navigable-minimap #navigableMinimap [class]="{'hidden': !useNavigable() || !navigableLoaded()}" class="pointer-events-none" [linkedMapViewer]="dvmService.viewer"/>
            <!-- MINIMAP CUSTOM (VIEWER SERVICE) -->
            @if(view()){
                <dvm-map-viewer [class]="{'hidden': useNavigable()}" class="h-full" [service]="minimap"/>
            }

        </div>

        <!-- ESTAS AQUI: no captura el raton para que el click llegue al sector -->
        @if(herePosition(); as position){
            <div
                class="absolute size-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-main ring-1 ring-white pointer-events-none"
                [style.left.px]="position[0]"
                [style.top.px]="position[1]"
            ></div>
        }

    </div>

</div>
